import CannabisLicenses from '../../components/cannabisLicenses/CannabisLicenses';

function LicenseTable() {
  return <CannabisLicenses />;
}

export default LicenseTable;
